var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeverageGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84856 23.0247C8.55279 22.829 8.5196 22.7144 8.63314 22.3697C9.50917 19.7546 10.3852 17.134 11.2667 14.5188C11.2937 14.4422 11.3153 14.3602 11.3477 14.2617C11.2494 14.2621 11.1838 14.2623 11.1128 14.2626C9.91605 14.2668 8.71933 14.271 7.52262 14.2752C7.09639 14.2767 6.93704 14.0259 7.12146 13.6373C8.7378 10.2108 10.3541 6.78431 11.965 3.35785C12.0735 3.12249 12.2425 3.02353 12.4994 3.02263C14.166 3.02221 15.8327 3.01088 17.4994 3.01046C17.9693 3.00881 18.1452 3.3142 17.9063 3.72488C16.7059 5.7947 15.5055 7.86452 14.3106 9.93432C14.2726 10 14.2346 10.0657 14.1803 10.1643C14.2732 10.1694 14.3443 10.1746 14.4098 10.1744C15.5628 10.1703 16.7158 10.1663 17.8634 10.1622C17.9289 10.162 17.9945 10.1563 18.0601 10.167C18.4537 10.2203 18.608 10.5804 18.3742 10.8981C17.9064 11.5227 17.4387 12.1473 16.9655 12.772C14.4635 16.0923 11.967 19.4181 9.46502 22.7329C9.37255 22.8534 9.2253 22.9359 9.09997 23.0347C9.00157 23.0242 8.92506 23.0244 8.84856 23.0247Z",
    fill: "url(#paint0_linear_1432_13696)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1432_13696",
    x1: 13.4985,
    y1: 0.519088,
    x2: 12.803,
    y2: 23.0217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#BB9E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#FFC738"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeverageGold);
export default __webpack_public_path__ + "static/media/leverage-gold.9edd5c342756449253afe8b17d6ef5eb.svg";
export { ForwardRef as ReactComponent };